export default __webpack_public_path__ + "static/media/allgemein_18.92134597.jpg";